(function () {
    'use strict';

    realmCommerceApp.run(runBlock);

    /*@ngInject*/
    function runBlock(formlyValidationMessages) {
        formlyValidationMessages.addStringMessage('required', 'This field is required');
        formlyValidationMessages.addTemplateOptionValueMessage('maxlength', 'maxlength', 'The max value allowed is', '', 'Too big');
        formlyValidationMessages.addTemplateOptionValueMessage('minlength', 'minlength', '', 'is the minimum length', 'Too short');
        var apiCheck = require('api-check');
        apiCheck.globalConfig.disabled = true;
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/config/app.run.js